import { configApi } from '../http-client.js'

export const getApiKeys = () => configApi.get('/api/ApiKeys')

export const deleteApiKey = uuid => configApi.delete(`/api/ApiKeys/${uuid}`)

export const upsertApiKey = apiKey => configApi.post('/api/ApiKeys/Upsert', apiKey)
